import { createTracker } from '@packages/shared';
import posthog from 'posthog-js';

/** Sends product analytics events to PostHog: `track('<event>', properties)` (see `createTracker`). */
export const track = createTracker({ posthog });
